import { render, staticRenderFns } from "./LhcUrl.vue?vue&type=template&id=5b20f86a&scoped=true&"
import script from "./LhcUrl.vue?vue&type=script&lang=js&"
export * from "./LhcUrl.vue?vue&type=script&lang=js&"
import style0 from "./LhcUrl.vue?vue&type=style&index=0&id=5b20f86a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b20f86a",
  null
  
)

export default component.exports